<template>
  <v-dialog
    :value="value"
    persistent
    max-width="700px"
    @click:outside="closeModal">
    <v-card subtitle="subtitle">
      <v-card-title>
        <v-icon color="primary">mdi-store</v-icon>
        <span class="pl-2">{{ storeParty.party_name }}</span>
        <v-spacer/>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="stores"
        :height="350"
        :items-per-page="-1"
        hide-default-footer>
        <template #[`item.start_dt`]="{ item }">
          <td class="noWrap">{{ formatDateDisplay(item.start_dt) }}</td>
        </template>
        <template #[`item.end_dt`]="{ item }">
          <td class="noWrap">{{ formatDateDisplay(item.end_dt) }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
import { userAccess } from '@/mixins/user-access'
import { displayHelpers } from '@/mixins/displayHelpers'
import { utils } from '@/mixins/utils'
import { shared } from '@/mixins/shared'

export default {
  name: 'StoreGroupModal',
  mixins: [userAccess, displayHelpers, utils, shared ],
  props: {
    value: Boolean,
    storeParty: Object,
    userStores: Array
  },
  data() {
    return {
      stores: [],
      headers: [
        { text: 'Store Name', value: 'store_name', class: 'accent white--text', align: 'start' },
        { text: 'Start Date', value: 'start_dt', class: 'accent white--text' },
        { text: 'End Date', value: 'end_dt', class: 'accent white--text' }
      ]
    }
  },
  watch: {
    storeParty: {
      async handler (newValue) {
        if (newValue) {
          if (this.storeParty?.children?.length > 0) {
            this.stores = this.userStores.filter(store => this.storeParty.children.flatMap(p => p.party_id).includes(store.store_party_id))
          } 
        }
      }
    }
  },
  async created() {
    if (this.storeParty?.children?.length > 0) { 
      this.stores = this.userStores.filter(store => this.storeParty.children.flatMap(p => p.party_id).includes(store.store_party_id))
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:value', false)
    },
  },
}
</script>